import React from "react";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { grey7, holoBlack } from "../../../constants/Colours";
import { secondsToPeriod } from "../../../utils/Date";
import { float2 } from "../../../utils/Number";

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.colors.holoBlack,
    letterSpacing: "0.75px",
    fontFamily: ["UniversLTStd"].join(","),
    fontStyle: "normal",
    lineHeight: "29px",
    fontWeight: 400,
    fontSize: 24,
    [theme.breakpoints.down("sm")]: {
      fontSize: 22,
      fontWeight: 400,
      lineHeight: "26px",
    },
  },
  explanation: {
    fontSize: 14,
    fontWeight: 300,
    letterSpacing: "0.75px",
    color: theme.palette.colors.grey7,
    fontFamily: "Light",
    lineHeight: "21px",
    fontStyle: "normal",
    whiteSpace: "pre-wrap",
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
      fontWeight: 300,
      letterSpacing: "0.016em",
      lineHeight: "140%",
    },
  },
}));

const DayGiltHeader = (props) => {
  const { time = "7" } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const period = secondsToPeriod(time);

  return (
    <Grid container item xs={12} spacing={2}>
      <Grid item xs={12}>
        <Typography variant="string" className={classes.title}>
          {t("mintingPage.giltTitle", {
            time:
              period.type === "day"
                ? t("mintingPage.days", { time: `${period.time}` })
                : t("mintingPage.hour", { time: `${float2(period.time)}` }),
          })}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="string" className={classes.explanation}>
          {period.type === "day" &&
            t("mintingPage.giltExplanation", { time: `${period.time} days` })}
          {period.type === "hour" &&
            t("mintingPage.giltExplanation", {
              time: `${float2(period.time)} hours`,
            })}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default DayGiltHeader;
